<template>
    <div
        class="mt-1 tags-input-wrapper">
        <vue-tags-input v-model="tag"
                        :tags="modelTags"
                        @tags-changed="updateTags"
                        :autocomplete-items="filteredTags"
                        class="text-sm focus:outline-none focus:border-none dark:text-gray-300 form-input"
        ></vue-tags-input>
    </div>
</template>

<script>
import VueTagsInput from '@sipec/vue3-tags-input';
import {ref, computed} from "vue";

export default {
    name: "TagsInput",
    components: {
        VueTagsInput,
    },
    props: {
        modelValue: {
            type: Array,
            default: [],
        },
        allTags: {
            type: Array,
            default: []
        }
    },
    setup(props, {emit}) {
        const tag = ref('');

        const modelTags = computed(() => {
            return props.modelValue.map((tagItem) => {
                return {
                    text: tagItem,
                    classes: 'px-1 mr-1 inline-flex text-xs text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red transition',
                };
            });
        });
        const updateTags = (newTags) => {
            emit('update:model-value', newTags.map((tag) => tag.text));
        };

        const filteredTags = computed(() => props.allTags.filter(i => {
            return i.text.toLowerCase().indexOf(tag.value.toLowerCase()) !== -1;
        }));

        return {
            tag,
            modelTags,
            updateTags,
            filteredTags,
        }
    }
}
</script>

<style>
.tags-input-wrapper .vue-tags-input {
    max-width: unset;
    background-color: inherit;
    border-color: #707275;
}

.tags-input-wrapper .vue-tags-input.ti-focus {
    box-shadow: 0 0 0 3px hsl(251deg 94% 87% / 45%);
    border-color: rgba(172, 148, 250, var(--tw-border-opacity));
}

.tags-input-wrapper .ti-input,
.tags-input-wrapper .ti-input:focus {
    border: none;
    box-shadow: none;
}

.ti-new-tag-input-wrapper input {
    background: transparent;
}

.ti-new-tag-input-wrapper input:focus {
    border: none;
    box-shadow: none;
}

.ti-autocomplete {
    box-shadow: 0 0 0 3px hsl(251deg 94% 87% / 45%);
    border-color: rgba(172, 148, 250, var(--tw-border-opacity));
    border-radius: 4px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.tags-input-wrapper .ti-tag {
    background-color: rgba(126, 58, 242, var(--tw-bg-opacity));
    border-radius: 0.5rem;
}

.tags-input-wrapper .ti-selected-item {
    background-color: rgba(126, 58, 242, var(--tw-bg-opacity));
}

.dark .vue-tags-input,
.dark .ti-autocomplete {
    background-color: rgba(36, 38, 45, 1);
}

.dark .tags-input-wrapper .vue-tags-input {
    border-color: rgba(76, 79, 82, var(--tw-border-opacity));
}

.dark .tags-input-wrapper .vue-tags-input.ti-focus,
.dark .ti-autocomplete {
    box-shadow: 0 0 0 3px hsl(210deg 2% 84% / 45%);
    border-color: rgba(76, 79, 82, var(--tw-border-opacity));
}

</style>
